import React from "react";

export default function EnterName() {
  return (
    <div>
      <p>EnterName</p>
    </div>
  );
}
